import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/AF';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

/**
 * 取得先前指定扣取每月費用之順序紀錄
 * @return {String} funddeFlg
 *  Y：有申請VU07(已申請)；N：申請VU07後又取消(未申請)；空白：沒有申請VU07(未申請)(保單無VU07條款,保單有VU07條款但沒有申請)
 * @return {Array} fundBankDtoList:
 * [{uallPert: 扣款順序, bankNo:投資標的公司代碼, bankName:投資標的公司名稱, fundCode:基金代號, fundName:基金名稱}]
 */
export function getInfoAF() {
    return get(`${url}/info`);
}

/**
 * 取得投資標的公司及投資標的名稱下拉式選單
 * @return {Array} bankVoList 投資標的公司清單
 * @return {Array} bankFundVoList 投資標的公司及投資標的清單
 */
export function getfundBankInfoAF() {
    return get(`${url}/fundBankInfo`);
}
/**
 * sumbit
 * @param {Object} data {funddeFlg:"string",fundBankList:"Array"}
 */
export function submitAF(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
}
